/**
 * O convite que esperou o login.
 *
 * Quem abre o link do convite sem sessao precisa entrar antes de aceitar, e o
 * login do admin termina onde sempre termina -- home, escolha de empresa,
 * segundo fator. Sem esta lembranca o convite se perderia exatamente ali: a
 * pessoa autentica e cai numa lista de empresas que nada tem a ver com o
 * convite que ela veio aceitar.
 *
 * `sessionStorage` e nao `localStorage`: o convite vale para esta aba e esta
 * ida ao login. Sobrar para a proxima sessao so criaria desvio inesperado.
 */
const CHAVE = 'convite:pendente';

export function guardarConvitePendente(token) {
    try {
        sessionStorage.setItem(CHAVE, token);
    } catch {
        // Navegador com armazenamento bloqueado: o aceite ainda funciona para
        // quem ja esta logado. Nao vale derrubar a tela por causa disso.
    }
}

export function convitePendente() {
    try {
        return sessionStorage.getItem(CHAVE);
    } catch {
        return null;
    }
}

export function esquecerConvitePendente() {
    try {
        sessionStorage.removeItem(CHAVE);
    } catch {
        // Idem: nada a fazer, e nada quebra.
    }
}
